module.exports = __webpack_public_path__ + "img/edits-submitted-icon.f60fed3d.png";